import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Modal, Button } from 'react-bootstrap' // Import Modal and Button from react-bootstrap
import GetAutoSuggestionsForTags from '../../Services/Queries/GetAutoSuggestionsForTags'
import UpdateMovie from '../../Services/Mutations/UpdateMovie'
import { Auth } from 'aws-amplify'
import Updateperson from '../../Services/Mutations/Updateperson'

const TfidbTags = props => {
  const { movieData, type } = props
  const [tags, setTags] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [suggestedTags, setSuggestedTags] = useState([])
  const [tagToRemove, setTagToRemove] = useState('')
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [addedTag, setAddedTag] = useState(false)
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const handleInputChange = async event => {
    setInputValue(event.target.value)
    if (event.target.value.length >= 3) {
      const input = {
        mode: 'TFIDB',
        contentType: type === 'person' ? 'person' : movieData.contentType,
        search: event.target.value,
        from: 0,
        limit: 10,
      }
      const suggestedTags = await GetAutoSuggestionsForTags(input)
      setSuggestedTags(suggestedTags.items ? suggestedTags.items : [])
    } else {
      setSuggestedTags([])
    }
  }

  // const handleInputKeyDown = event => {
  //   if (event.key === 'Enter' && inputValue.trim() !== '') {
  //     const tagToAdd = inputValue.trim()
  //     if (!tags.includes(tagToAdd)) {
  //       setTags([...tags, tagToAdd])
  //     }

  //     setInputValue('')
  //     setSuggestedTags([])
  //   }
  // }

  const handleTagRemove = tag => {
    setTagToRemove(tag)
    setShowConfirmationModal(true)
  }

  const confirmTagRemoval = async () => {
    if (type === 'person') {
      const input = {
        PK: movieData.PK,
        SK: movieData.SK,
        moderatorID: Auth.user.username,
        moderatorHandle: loggedInUserHandle,
        tags: tags.filter(tag => tag !== tagToRemove),
      }
      try {
        const upadatelog = await Updateperson(input)
        if (upadatelog.statusCode === 'A002') {
          setTags(tags.filter(tag => tag !== tagToRemove))
          setShowConfirmationModal(false)
          setAddedTag(false)
          return upadatelog
        }
      } catch (error) {
        console.warn(error)
      }
    } else {
      const input = {
        PK: movieData.PK,
        SK: movieData.SK,
        movieID: movieData.movieID,
        contentType: movieData.contentType,
        moderatorID: Auth.user.username,
        moderatorHandle: loggedInUserHandle,
        tags: tags.filter(tag => tag !== tagToRemove),
        // movieAndOTTNewsUpdates: updatedMovieAndOTTNewsUpdates,
      }
      await UpdateMovie(input)
      setTags(tags.filter(tag => tag !== tagToRemove))
      setShowConfirmationModal(false)
      setAddedTag(false)
    }
  }

  const handleTagSuggestionClick = async tag => {
    setInputValue('')
    setSuggestedTags([])
    if (!tags.includes(tag.tagURL)) {
      setTags([...tags, tag.tagURL])
      // service call for upadate move
      if (type === 'person') {
        const input = {
          PK: movieData.PK,
          SK: movieData.SK,
          moderatorID: Auth.user.username,
          moderatorHandle: loggedInUserHandle,
          tags: [...tags, tag.tagURL],
        }
        try {
          const upadatelog = await Updateperson(input)
          if (upadatelog.statusCode === 'A002') {
            setAddedTag(true)
            return upadatelog
          }
        } catch (error) {
          console.warn(error)
        }
      } else {
        const input = {
          PK: movieData.PK,
          SK: movieData.SK,
          movieID: movieData.movieID,
          contentType: movieData.contentType,
          tags: [...tags, tag.tagURL],
          moderatorID: Auth.user.username,
          moderatorHandle: loggedInUserHandle,
          // movieAndOTTNewsUpdates: updatedMovieAndOTTNewsUpdates,
        }
        await UpdateMovie(input)
      }

      setAddedTag(true)
    }
  }

  useEffect(() => {
    setTags(movieData && movieData.tags ? movieData.tags : [])
  }, [movieData])
  return (
    <div>
      <div>
        <label>Tags:</label>
        {addedTag && (
          <div
            className='mandatory1'
            style={{ float: 'right', position: 'relative', bottom: '20px' }}
          >
            Tag Added!
          </div>
        )}
        {tags.length >= 1 && (
          <div style={{ border: '1px solid black', padding: '5px' }}>
            {tags.map((tag, index) => (
              <span
                key={index}
                className='badge mr-2'
                style={{ color: 'black', border: '1px solid black' }}
              >
                {tag}
                <button
                  type='button'
                  onClick={() => handleTagRemove(tag)}
                  className='btn btn-sm btn-danger ml-1'
                  style={{
                    borderRadius: '50%',
                    width: '20px',
                    height: '20px',
                    padding: '0',
                    position: 'relative',
                    right: '-5px',
                  }}
                >
                  <span style={{ position: 'absolute', bottom: '0px', left: '6px' }}>x</span>
                </button>
              </span>
            ))}
          </div>
        )}
      </div>
      <input
        type='text'
        value={inputValue}
        onChange={handleInputChange}
        // onKeyDown={handleInputKeyDown}
        className='form-control mt-2'
        placeholder='Add tags...'
      />
      <div>
        {suggestedTags.map((tag, index) => (
          <span
            key={index}
            className='badge badge-secondary m-1'
            onClick={() => handleTagSuggestionClick(tag)}
          >
            {tag.tagURL}
          </span>
        ))}
      </div>
      {/* Confirmation Modal */}
      <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Tag Removal</Modal.Title>
        </Modal.Header>
        <Modal.Body>{`Are you sure you want to remove the tag "${tagToRemove}"?`}</Modal.Body>
        <Modal.Footer>
          <Button
            variant='secondary'
            onClick={() => {
              setShowConfirmationModal(false)
              setAddedTag(false)
            }}
          >
            Cancel
          </Button>
          <Button variant='danger' onClick={confirmTagRemoval}>
            Remove
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default TfidbTags
